export enum IngredientType {
  Official = 'official',
  Suggested = 'suggested',
}
